import {
  getCountries,
  getCountryCallingCode,
  parsePhoneNumberFromString,
  parsePhoneNumberWithError,
} from 'libphonenumber-js';

// LIST OF PREFIX COUNTRIES
export const COUNTRIES = getCountries().map(code => ({ code, prefix: getCountryCallingCode(code) }));

// TRY TO PARSED PHONE NUMBER
function parsedPhoneNumber(phone: string) {
  if (!phone || phone.trim() === '' || phone.length < 2) return null;

  return parsePhoneNumberFromString(phone, 'FR');
}

// Notional format for display
export function getFormatNational(phone: string) {
  return parsedPhoneNumber(phone)?.formatNational() || null;
}

// E164 FORMAT FOR SAVE NUMBER IN BDD
export function getFormatE164(phone: string) {
  return parsedPhoneNumber(phone)?.number || null;
}
